import React, { useState } from 'react';

import './Card.scss';

import { config } from '../../../../config/config';
import { Button, ButtonSize } from '../../../shared/components/button/button';
import { ContentMarkdown } from '../../../shared/components/content-markdown/content-markdown';
import { FormattedMessage } from '../../../shared/components/formatted-message/formatted-message';
import { Icon } from '../../../shared/components/icon/icon';
import { ModalContainer } from '../../../shared/components/modal-container/modal-container';

type Props = {
    title: string;
    body: string;
    image: string;
    banner?: string;
    classCard: string;
    href?: string;
    tandc?: string;
    blank?: boolean;
};

const Card = (props: Props) => {
    const { title = '', image = '', tandc = '' } = props;
    const [isOpen, setIsOpen] = useState(false);
    const [description, setDescription] = useState('');
    const onClose = () => {
        setIsOpen(false);
    };
    const onIcon = () => {
        setIsOpen(false);
    };

    const toggle = (tandc: string) => {
        setIsOpen(true);
        if (tandc) {
            setDescription(tandc);
        } else {
            setDescription('Under construction');
        }
    };

    return (
        <div className="card-promo">
            <div className="img-container-promo">
                <img src={`${config.ASSET_URL}/${image}`} alt="" className="card-img-promo" />
            </div>
            <div className="card-details-promo">
                <div className="card-title-promo">
                    <h5>{title}</h5>
                </div>
                <div className="card-button-promo">
                    <Button
                        size={ButtonSize.MEDIUM}
                        className={'card-button-color'}
                        rawHref={true}
                        onClick={() => toggle(tandc)}
                    >
                        LEARN MORE
                    </Button>
                </div>
            </div>
            {isOpen && (
                <ModalContainer onClose={onClose}>
                    <section className={'promo-prompt'}>
                        <h1 className="promo-prompt__title">
                            <FormattedMessage
                                id={'promo.block.title'}
                                defaultMessage={'Terms & Conditions'}
                            />
                        </h1>
                        <Icon
                            className={'promo-prompt__icon'}
                            name={'close-large'}
                            onClick={onIcon}
                        />

                        <div className="promo-prompt__description">
                            <ContentMarkdown markdown={description} />
                        </div>
                    </section>
                </ModalContainer>
            )}
        </div>
    );
};
export default Card;
